module.exports = __webpack_public_path__ + "static/media/hilda-lose.c940fb4a.png";